"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  kr: "ja",
  한국어: "일본어",
  "받은 알림이 없습니다.": "受信した通知がありません。",
  알림: "通知",
  설정: "設定",
  "모두 읽음": "全て既読にする",
  "읽은 알림 삭제": "既読済通知削除",
  "모두 삭제": "全て削除",
  "변경했던 모든 세부 설정값을 초기 상태로 되돌립니다.\n초기화한 알림 설정은 저장 시 적용됩니다.": "変更したすべての設定詳細を初期の状態に戻します。\n初期化した通知設定は保存時、適応されます。",
  "알림 콘텐츠 설정": "通知コンテンツ設定",
  초기화: "初期化",
  저장: "保存",
  "설정이 저장되었습니다.": "設定が保存されました。",
  "설정 저장을 실패했습니다.": "設定保存が失敗しました。",
  "x 알림 x": "",
  "알림 설정": "通知設定",
  "에서 받고 싶은 알림을 선택하세요.": "から受信する通知を選択してください。",
  "안내": "案内",
  "더보기": "もっと見る",
  "<em onclick={{handleGoLogin}}>로그인</em>하시면<br />좋아하시는 BJ와 방송의<br />새로운 소식을 알려드립니다.": "<em onClick={{handleGoLogin}}>ログイン</em>すると<br />好きなBJ及び放送の<br />最新情報をお届けします。"
};